import React from "react";
import { Spinner } from "./spinner";

export function LoadingOverlay() {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
      <Spinner size={48} className="text-white" />
    </div>
  );
}
